import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('close-one', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: props.colors[0],
    cx: "64",
    cy: "64",
    r: "64"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.633920, 36.636297)",
    fill: props.colors[1]
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33892571,1.33892571 C3.12416,-0.446308571 6.01869714,-0.446308571 7.80393143,1.33892571 L53.0584229,46.5938743 C54.8440229,48.3794743 54.8440229,51.2731886 53.0584229,53.0587886 C51.2737371,54.8443886 48.3791086,54.8443886 46.5935086,53.0587886 L1.33892571,7.80393143 C-0.446308571,6.01869714 -0.446308571,3.12416 1.33892571,1.33892571 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0533943,1.33892571 C48.83808,-0.446308571 51.7327086,-0.446308571 53.5183086,1.33892571 C55.3039086,3.12416 55.3039086,6.01869714 53.5183086,7.80393143 L8.26336,53.0587886 C6.47812571,54.8443886 3.58368,54.8443886 1.79844571,53.0587886 C0.01312,51.2731886 0.01312,48.37856 1.79844571,46.5938743 L47.0533943,1.33892571 Z"
  })))));
});